module.exports = __webpack_public_path__ + "1.4.15-unryo/img/offline-vault-2.04b4fe35.svg";